import React, { Component } from "react";
import PropTypes from "prop-types";
import Snackbar from "@material-ui/core/Snackbar";
import { connect } from "react-redux";
import { hideNotification } from "../../redux/actions/notification";
import locale from "../../utils/locale";

import "./Snackbar.css";

class Notification extends Component {
  render() {
    const { notify, message, type, hideNotification } = this.props;

    return (
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={notify}
        autoHideDuration={2000}
        onClose={hideNotification}
        ContentProps={{
          "aria-describedby": "message-id"
        }}
        message={message ? message : locale("network_error")}
      />
    );
  }
}

const mapStateToProps = state => ({
  notify: state.notification.notify,
  message: state.notification.message,
  type: state.notification.type
});
const mapDispatchToProps = {
  hideNotification
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Notification);

Notification.propTypes = {
  notify: PropTypes.bool,
  message: PropTypes.string,
  type: PropTypes.string
};




// WEBPACK FOOTER //
// ./src/containers/Notification/index.js